<div class="setting-row__text">
  <span class="setting-row__label" [id]="labelId">
    {{ label }}
    @if (required) {
      <span class="setting-row__required" aria-hidden="true">*</span>
    }
  </span>
  @if (description) {
    <span class="setting-row__description">{{ description }}</span>
  }
</div>
<div class="setting-row__controls">
  <ng-content></ng-content>
</div>
